import { BabyFaceOutlineIcon } from './BabyFaceOutlineIcon';

/**
 * author: Google
 * id 24C6F5BD-6965-4CDB-B3AC-02CA82F24216
 * name baby-face-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/baby-face-outline.svg
 * tags
 * - People / Family 
 */
export const EmojiBabyOutlineIcon = BabyFaceOutlineIcon;
export default EmojiBabyOutlineIcon